import { render, staticRenderFns } from "./ItemShow.vue?vue&type=template&id=a97c7696&scoped=true&"
import script from "./ItemShow.vue?vue&type=script&lang=js&"
export * from "./ItemShow.vue?vue&type=script&lang=js&"
import style0 from "./ItemShow.vue?vue&type=style&index=0&id=a97c7696&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97c7696",
  null
  
)

export default component.exports